import _ from 'lodash'
import statusCode from './statusCode'

export const {
  statusCodes,
  statusCodeToText,
  statusTextToCode
} = statusCode.diamond

// Two codes read 'sold': 4 (SOLD) and 5 (SOLD_OUT), the one the API writes the
// moment the last unit goes. Comparing against statusCodes.SOLD.value alone
// therefore misses every sold-out row — including in the edit form, which left
// the whole Item Status group unselected for items the inventory list was
// already badging as "Sold". Matching on the text covers both, exactly as the
// list column does via statusCodeToText.
export const isSoldStatusCode = code =>
  statusCodeToText(code) === statusCodes.SOLD.text

export const jewelryTypes = {
  ring: 'Ring',
  'mens-ring': "Men's Ring",
  'engagement-ring': 'Engagement Ring',
  'wedding-band': 'Wedding Band',
  'engagement-band-set': 'Engagement/Band Set',
  pendant: 'Pendant',
  bracelet: 'Bracelet',
  earrings: 'Earrings',
  'stud-earrings': 'Stud Earrings',
  watch: 'Watch',
  'wire-wrap': 'Wire Wrap',
  necklace: 'Necklace',
  broach: 'Broach',
  'flexible-link-ring': 'Flexible Link Ring',
  coin: 'Coin',
  other: 'Other'
}

export const settings = {
  loose: 'Loose',
  mounted: 'Mounted',
  'non-diamond-jewelry': 'Non-diamond Jewelry',
  gemstone: 'Gemstone',
  'craft-jewelry': 'Craft Jewelry',
}
